import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { Link } from 'react-router-dom';
import { fetchCollection, addTournamentToDb, addAssociationToDb, addGolfCourseToDb } from './utils';
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css';
import Switch from "react-switch";
import { auth } from '../../firebase';
import {allCountries} from 'country-region-data'; // Import country-region data

const countryStateMap = {};
allCountries.forEach(([countryName, countryCode, regions]) => {
    countryStateMap[countryName] = regions.map(region => region[0])
});

function CreateGolfCourse() {
    const [loading, setLoading] = useState(true)
    const [userId, setUserId] = useState("")
    const [golfCourses, setGolfCourses] = useState([])

    const [countryListForSelect, setCountryListForSelect] = useState([])
    const [stateListForSelect, setStateListForSelect] = useState([])

    const [name, setName] = useState("")
    const [country, setCountry] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [website, setWebsite] = useState("")

    // Update state/province options when country changes
    useEffect(() => {
        if (country && country.value && countryStateMap[country.value]) {
            setStateListForSelect(
                countryStateMap[country.value].map((s, i) => ({
                    label: s,
                    value: s,
                    id: i
                }))
            );
        } else {
            setStateListForSelect([]);
        }
        setState(""); // Reset state/province when country changes
    }, [country]);

    const createGolfCourse = async () => {
        setLoading(true)
        const docRef = await addGolfCourseToDb({
            name: name,
            country: country.value,
            city: city,
            state: state ? state.value : "",
            website: website,
            createdBy: userId,
            createdAt: new Date().toISOString()
        })
        console.log("golf course document written with ID: ", docRef.id);
        resetForm()
        setLoading(false)
    }

    const resetForm = () => {
        setName("")
        setCountry("")
        setCity("")
        setState("")
        setWebsite("")
    }

    const fetchData = async () => {
        setLoading(true)
        const currentUser = auth.currentUser ? auth.currentUser.uid : ""
        setUserId(currentUser)

        // Get all countries, but put United States and Canada first
        const allCountries = Object.keys(countryStateMap);
        const priorityCountries = ["United States", "Canada"];
        const sortedCountries = [
            ...priorityCountries.filter(c => allCountries.includes(c)),
            ...allCountries.filter(c => !priorityCountries.includes(c))
        ];

        const countryListForSelectLocal = sortedCountries.map((c, i) => ({
            label: c,
            value: c,
            id: i
        }));
        setCountryListForSelect(countryListForSelectLocal);
        setLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, []);

    if (loading) {
        return (
            <div className="admin-login-bg">
                <div className="admin-login-card">
                    <div className="admin-login-loading">
                        <div className="admin-login-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-login-bg">
            <div className="admin-login-card" style={{ maxWidth: 500 }}>
                <h1 className="admin-login-title">Create Golf Course</h1>
                <form className="admin-login-form" style={{ gap: "1.2rem" }}>
                    <div>
                        <label className="admin-login-label">Golf Course Name</label>
                        <input
                            className="admin-login-input"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            placeholder="Enter course name"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">City</label>
                        <input
                            className="admin-login-input"
                            value={city}
                            onChange={e => setCity(e.target.value)}
                            placeholder="Enter city"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">Country</label>
                        <Select
                            isDisabled={false}
                            isMulti={false}
                            menuPlacement='auto'
                            menuPosition='fixed'
                            options={countryListForSelect}
                            value={country}
                            onChange={setCountry}
                            placeholder="Select country"
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">State / Province / Region</label>
                        <Select
                            isDisabled={!stateListForSelect.length}
                            isMulti={false}
                            menuPlacement='auto'
                            menuPosition='fixed'
                            options={stateListForSelect}
                            value={state}
                            onChange={setState}
                            placeholder={stateListForSelect.length ? "Select state/province/region" : "No options"}
                        />
                    </div>
                    <div>
                        <label className="admin-login-label">Website</label>
                        <input
                            className="admin-login-input"
                            value={website}
                            onChange={e => setWebsite(e.target.value)}
                            placeholder="Enter website URL"
                        />
                    </div>
                    <div style={{ marginTop: "1.5rem" }}>
                        <button
                            className="admin-login-btn"
                            type="button"
                            onClick={createGolfCourse}
                        >
                            Create Golf Course
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CreateGolfCourse;